import { defineMessages } from 'react-intl'

export const pendingJobsTableMessages = defineMessages({
  jobName: {
    id: 'pendingJobsTable.jobName',
    description: "Title for Pending Jobs table column of Job's name",
    defaultMessage: 'Job Name',
  },
  updated: {
    id: 'pendingJobsTable.updated',
    description: "Title for Pending Jobs table column of job's Updated date",
    defaultMessage: 'Updated',
  },
})
